module.exports = __webpack_public_path__ + "static/img/thumb_16.4391fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_16.jpg
// module id = uJRa
// module chunks = 0